'use strict';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import AutocompleteItem from './AutocompleteItem';

const API_AUTOCOMPLETE_URL = '/api/places/autocomplete';

class Autocomplete extends React.Component {
  static propTypes = {
    updater: PropTypes.object.isRequired,
    defaultValue: PropTypes.string,
    language: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    data: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue,
      data: props.data || [],
    };
  }

  handleClickOutside() {
    this.setState({data: []});
  }

  handleChange = (e) => {
    var value = e.target.value;
    if (value === '') {
      this.setState({data: [], value: value});
    } else {
      this.setState({value: value});
      this.callApiToAutocomplete(value);
    }
  }

  handleItemClick = (value) => {
    this.setState({data: [], value: value});
  }

  callApiToAutocomplete(value) {
    var language = this.props.language;
    fetch(`${API_AUTOCOMPLETE_URL}?city=${encodeURIComponent(value)}&language=${language}`)
      .then(
        this.handleResponse.bind(this)
      );
  }

  handleResponse(res) {
    if (res.ok) {
      res.json().then(this.handleData.bind(this));
    }
  }

  handleData(data) {
    this.setState({ data: data.payload });
  }

  render() {
    return (
      <div className="autocomplete-wrap">
        <input
          ref="input"
          className="form-control"
          autoComplete="off"
          type="text"
          name={this.props.name}
          value={this.state.value}
          onChange={this.handleChange} />
        <ul className="autocomplete-menu">{
          this.state.data.map((item, idx) =>
            (<AutocompleteItem
              key={item.place_id || idx}
              place={item}
              updater={this.props.updater}
              handleItemClick={this.handleItemClick} />)
          )
        }</ul>
      </div>
    );
  }
}

export default onClickOutside(Autocomplete);
